export * from './fake-backend';



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/auth/_helpers/index.ts